import React, { Component } from 'react';
import { push } from "../Services/Analytics"
import { FallenAPI } from "../Services/fetchService"
import Loading from "../Services/Loading/Loading"
import FallenItem from "./FallenItem"
import './Fallen.scss';

class Fallen extends Component {
    constructor() {
        super();
        this.state = {
            items: []
        }
        this.checkScrollPos = this.checkScrollPos.bind(this);
    }
    async componentDidMount() {
        await this.props.showLoader();
        this.setState({
            items: await FallenAPI.get()
        })
        await this.props.showLoader();
        if (!this.props.shouldScrollTop) {
            if (typeof (Storage) !== "undefined") {
                if (window.sessionStorage.getItem("scrollY")) {
                    window.scrollTo(0, window.sessionStorage.getItem("scrollY"))
                }
            }
        }
    }
    renderItem() {
        return this.state.items.map((item, index) =>
            <FallenItem key={index}
                index={index}
                item={item}
            />
        )
    }
    checkScrollPos(event) {
        if (typeof (Storage) !== "undefined") {
            window.sessionStorage.setItem("scrollY", window.scrollY);
        }
    }
    render() {
        return (
            <section className="section section-fallen">
                <div className="padding">
                    <div className="container" onClick={(e) => this.checkScrollPos(e)}>
                        <Loading showLoading={this.props.isLoading} />
                        {this.renderItem()}
                    </div>
                </div>
            </section>
        );
    }
}

export default Fallen;



// WEBPACK FOOTER //
// ./src/Components/Fallen/Fallen.jsx